const rawFlag = (process.env.REACT_APP_CHECKOUT_DEBUG || '').trim().toLowerCase();
const enabled = rawFlag === '1' || rawFlag === 'true' || rawFlag === 'yes';

export const isCheckoutDebugEnabled = enabled;

const resolveConsole = (level) => {
  if (level === 'warn') return console.warn;
  if (level === 'error') return console.error;
  if (level === 'table' && console.table) return console.table;
  return console.info;
};

export const checkoutDebugLog = (level, message, payload) => {
  if (!enabled) {
    return;
  }
  const logger = resolveConsole(level);
  if (payload !== undefined) {
    logger(`[CheckoutDebug] ${message}`, payload);
  } else {
    logger(`[CheckoutDebug] ${message}`);
  }
};

export const summarizeCartSnapshot = (cart) => {
  if (!cart) {
    return { itemCount: 0, items: [] };
  }
  const items = Array.isArray(cart.items) ? cart.items : [];
  return {
    itemCount: items.length,
    items: items.map((item) => ({
      productSlug: item?.productSlug || null,
      planKey: item?.planKey || null,
      quantity: item?.quantity ?? 1,
    })),
    flowContext: cart.flowContext || null,
  };
};

